import type { GuestOs } from './api.js';

/**
 * Infer the INTERACTIVE guest OS from a sample's magic bytes + filename so an ELF gets a Linux VM
 * (not Windows), an APK gets Android, and a shell script routes to Linux. Falls back to Windows (the
 * common case) for PE/unknown. Shared by the Submit and Live pages so per-file inference is identical
 * everywhere. Note: the interactive tier is Windows/Linux/Android only (no macOS guest), so a Mach-O
 * falls through to the Windows default and the server's OS-availability preflight explains the gap.
 */
export function inferGuestOs(buf: ArrayBuffer, fileName: string): GuestOs {
  const b = new Uint8Array(buf.slice(0, 64));
  // ELF
  if (b[0] === 0x7f && b[1] === 0x45 && b[2] === 0x4c && b[3] === 0x46) return 'linux';
  // APK (ZIP container) by extension, or any .apk name
  if (/\.apk$/i.test(fileName) && b[0] === 0x50 && b[1] === 0x4b) return 'android';
  // PE 'MZ'
  if (b[0] === 0x4d && b[1] === 0x5a) return 'windows';
  // Shell script: a shebang, or a .sh/.bash filename.
  const head = new TextDecoder('utf-8', { fatal: false }).decode(b);
  if (/^#!/.test(head) || /\.(sh|bash|bin|elf|run)$/i.test(fileName)) return 'linux';
  return 'windows';
}
